import React from "react";
import { Link, useLocation } from "react-router-dom";
import "./Navbar.css"; // 👈 引入样式

function Navbar() {
  const location = useLocation();
  const isHome = location.pathname === "/";
  const isApp = location.pathname === "/app";
  const isDev = location.pathname === "/developer";

  return (
    <nav className="navbar">
      <Link to="/" className="navbar-brand">
        热茶满座
      </Link>

      <div className="navbar-links">
        {isHome && (
          <>
            <Link to="/app" className="navbar-link primary">
              思考链条
            </Link>
            <Link to="/developer" className="navbar-link outline">
              开发者
            </Link>
          </>
        )}
        {(isApp || isDev) && (
          <Link to="/" className="navbar-link outline">
            返回首页
          </Link>
        )}
      </div>
    </nav>
  );
}

export default Navbar;
